/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

import { QueryClientProvider } from '@tanstack/react-query';
import { type JSX } from 'react';
import { RouterProvider } from 'react-router-dom';

import { queryClient } from './lib/query-client.js';
import { router } from './router/index.js';

/**
 * Root application component. Hands the shared React Query client and the
 * router off to React. Keeping this lean — every concrete surface is reached
 * through the router.
 */
export function App(): JSX.Element {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
}
